import D1 from '../../components/ExcerciseTypes/Design/TypeIn';


const json = {


  1: { // Exercise num
    unit: 'Unit 8',
    id: 'WB3-U8-P54-E1',
    audio: '',
    video: '',
    component: D1,
    maxLength: 1,
    exerciseKey: 'img/FriendsPlus/Page54/E1/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page54/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page54/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page54/E1/3.jpg', input: true, answer: "s" },
        { url: 'img/FriendsPlus/Page54/E1/4.jpg', input: true, answer: "u" },
        { url: 'img/FriendsPlus/Page54/E1/5.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page54/E1/6.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page54/E1/7.jpg', input: true, answer: "y" },
        { url: 'img/FriendsPlus/Page54/E1/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page54/E1/9.jpg' },
      ],
      [
        // Column4 raining   snowing
        { url: 'img/FriendsPlus/Page54/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page54/E1/11.jpg', input: true, answer: "r" },
        { url: 'img/FriendsPlus/Page54/E1/12.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page54/E1/13.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page54/E1/14.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page54/E1/15.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page54/E1/16.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page54/E1/17.jpg', input: true, answer: "g" },
        { url: 'img/FriendsPlus/Page54/E1/18.jpg' },
        { url: 'img/FriendsPlus/Page54/E1/19.jpg', input: true, answer: "s" },
        { url: 'img/FriendsPlus/Page54/E1/20.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page54/E1/21.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page54/E1/22.jpg', input: true, answer: "w" },
        { url: 'img/FriendsPlus/Page54/E1/23.jpg', input: true, answer: "i" },
        { url: 'img/FriendsPlus/Page54/E1/24.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page54/E1/25.jpg', input: true, answer: "g" },
        { url: 'img/FriendsPlus/Page54/E1/26.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page54/E1/27.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page54/E1/28.jpg' },
        { url: 'img/FriendsPlus/Page54/E1/29.jpg', input: true, answer: "h" },
        { url: 'img/FriendsPlus/Page54/E1/30.jpg', input: true, answer: "o" },
        { url: 'img/FriendsPlus/Page54/E1/31.jpg', input: true, answer: "t" },
        { url: 'img/FriendsPlus/Page54/E1/32.jpg' },
      ],
    ]
  },
  2: { // Exercise num
    unit: 'Unit 8',
    id: 'WB3-U8-P54-E2',
    audio: '',
    video: '',
    component: D1,
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page54/E2/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page54/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page54/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page54/E2/3.jpg', input: true, answer: "It's snowing." },
        { url: 'img/FriendsPlus/Page54/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page54/E2/5.jpg', input: true, answer: "It's hot." },
        { url: 'img/FriendsPlus/Page54/E2/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page54/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page54/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page54/E2/9.jpg', input: true, answer: "It's sunny." },
        { url: 'img/FriendsPlus/Page54/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page54/E2/11.jpg', input: true, answer: "It's raining." },
        { url: 'img/FriendsPlus/Page54/E2/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page54/E2/13.jpg' },
      ],
    ]
  },
}
export default json;